export class ReferralSource {
  personSk?: string;
  personType?: number | null;
  personTypeText?: string;
  referralSourceTypeValue: string;
  personCategory?: number = 3;
  personCategoryText?: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  email: string;
  phone?: string;
  title?: string;
  role?: string;
}

// TODO: This needs to be removed, please see comment below
export interface ReferralStatus {
  Open: number;
  Draft: number;
  PendingReview: number;
  ReviewCompletion: number;
  Accepted: number;
  Closed: number;
  Rejected: number;
  PendingPWN: number;
  Cancelled: number;
  ScheduleSHM: number;
  SHMScheduled: number;
  GenEdScheduled: number;
  NotSpecified: number;
}

// TODO: This needs to be removed as this is a reference to `CaseActionStatusId` enum in shared/enums/case-action-status.ts
export const ReferralStatusModel: ReferralStatus = {
  Open: 1,
  Draft: 2,
  PendingReview: 3,
  ReviewCompletion: 5,
  Accepted: 6,
  Closed: 7,
  Rejected: 8,
  PendingPWN: 9,
  Cancelled: 10,
  ScheduleSHM: 11,
  SHMScheduled: 12,
  GenEdScheduled: 13,
  NotSpecified: 999,
};

export interface DocumentsStatusModel {
  SaveForLater: number;
  Submit: number;
  Approve: number;
  Reject: number;
  Request: number;
  SHP: number;
  Finalize: number;
  Cancelled: number;
}

export const DocumentStatus: DocumentsStatusModel = {
  SaveForLater: 1,
  Submit: 2,
  Approve: 3,
  Reject: 4,
  Request: 5,
  SHP: 6,
  Finalize: 7,
  Cancelled: 9,
};

export class AddReferralRequest {
  referralSk: string;
  referringPerson?: string;
  refFirstName: string;
  refLastName: string;
  refEmail: string;
  studentSK: string;
  studentOSISId: string;
  schoolDBN: string;
  actionType: number;
  caseManagerPerson: string;
  eventDateTime: Date;
  explanation: string;
  homeLanguage: number;
  spokeLanguage: number;
  writtenLanguage: number;
  seqNo: number;
  caseNumber: string;
  completedDate: Date;
  caseEventType: number;
  regComplianceDate: Date;
  receivedDate: Date;
  studentLanguages: number[];
  referralReason: string;
  descProposedUse: string;
  numberofCredits: string;
  cumDaysAbsent: number;
  studentLivedOutsideUsa: boolean;
  yearsinElschool?: number;
  lengthofUsresidency?: number;
  unitofResidencyLength?: string;
  strengthandWeaknessDesc: string;
  behaviorDesc: string;
  medicationsHealthConcernsDesc: string;
  isGradeHoldover: boolean;
  hasPIP: boolean;
  isELL: boolean;
  isRecvBilingualEducation: boolean;
  wearsGlasses: boolean;
  wearsHearingAid: boolean;
  referralType: number;
  referralTypetext: string;
  referralStatus: number;
  referralStatustext: string;
  prefLanguage: number;
  prefLanguagetext: string;
  attendancePattern: number;
  cboName: number;
  cboServices: string;
  referralSource: ReferralSource;
  instructionalLevels: InstructionalLevels[];
  interventionStrategies: InterventionStrategies[];
  isPublic?: boolean;
}

export class ReferralInfo {
  referralSk?: string;
  studentSK?: string;
  eventDateTime?: Date;
  explanation?: string;
  seqNo?: number;
  caseNumber?: number;
  completedDate?: Date;
  caseEventType?: number;
  regComplianceDate?: Date;
  receivedDate?: Date;
  referralReason?: string;
  studentLivedOutsideUSA?: boolean;
  numberofCredits?: string;
  cumDaysAbsent?: number;
  referralType?: number;
  actionType?: number;
  hasPip?: boolean;
  isRecvBilingualEducation?: boolean;
  isGradeHoldover?: boolean;
  wearsGlasses?: boolean;
  wearsHearingAid?: boolean;
  takesMedications?: boolean;
  strengthandWeaknessDesc?: string;
  behaviorDesc?: string;
  currentYrHoldover?: boolean;
  sharedAccountability?: boolean;
  disability?: boolean;
  expirationDate?: string;
  whyCanceled?: string;
  referralStatus?: number;
  legacyId?: string;
  attendancePattern?: number;
  cboservices?: string;
  cboname?: number;
  eiautoEligible?: string;
  preferredCommMethod?: number;
  yearsinElschool?: number;
  lengthofUsresidency?: number;
  unitofResidencyLength?: string;
  lastModuser?: string;
  lastModTs?: string;
  studentLanguages: number[];
  studentLanguageDetails?: Record<number, string>;
  caseManagerPerson?: string;
  referralSource: ReferralSource; // Not sure if this should be replaced with the `Person` interface in the `person.ts` file, because the personCategory has been explicity set to 3.
  instructionalLevels?: InstructionalLevels[];
  interventionStrategies?: InterventionStrategies[];
  medicationsHealthConcernsDesc?: string;
  studentOSISId?: string;
  schoolDBN?: string;
  isELL?: boolean;
  cboNameText?: string;
  referralTypetext?: string;
  referralStatustext?: string;
  isPublic: boolean;
  academics?: string;
  needExpl?: string;
  ppReasonforReferral: number[];
  ppOtherReasonforReferral?: string;
  uploadedDate?: string;
  homeLanguage?: number;
  spokeLanguage?: number;
  writtenLanguage?: number;
  receivingService?: string;
  classOrHomeRoomTeacherName?: string;
  classOrHomeRoomTeacherEmail?: string;
  classOrHomeRoomTeacherSk?: string;
  referringPerson: string;
  initialReferralDate: Date;
  descProposedUse: string;
  prefLanguage: number;
  prefLanguagetext: string;
}

export class InstructionalLevels {
  referralSk: string;
  seqNo: number;
  type?: string;
  functionalLevel?: number;
  nativeLanguageLevel?: number;
}

export enum eNumInstructionLevel {
  Reading = 'Reading',
  Math = 'Math',
  WrittenLanguage = 'WrittenLanguage',
}

export enum eNumAttendancePattern {
  Good = 1,
  Bad = 2,
}

export interface InterventionStrategies {
  referralSk?: string;
  interventionDesc?: string;
  interventionType?: string | number;
  tierType?: string | number;
  seqNo: number;
  initDate: Date;
  termDate?: Date;
  interventionOther?: string;
  numDaysRecd?: number;
  interventionName?: string;
  interventionTitle?: string;
  interventionTypeDesc?: string;
  tierTypeDesc?: string;
}

export enum ReferralType {
  InitialReferral = 1,
  RequestForAdditionalReevaluation = 2,
  RequestForInitialReferral = 3,
  RequestForReevaluation = 4,
  Mandate3Year = 19,
  NotSpecified = 999,
}

export interface ReferralDetails {
  referralSk: string;
  referraltype?: number;
  referralStatus?: number;
  actualDate?: Date;
}
